// src/admin/components/FilterChip.tsx
import type { ReactNode } from 'react';
import styles from './FilterChip.module.css';

export default function FilterChip({
  label, active = false, onClick, count,
}: { label: ReactNode; active?: boolean; onClick: () => void; count?: number }) {
  return (
    <button type="button" onClick={onClick} className={`${styles.chip} ${active ? styles.active : ''}`}>
      {label}
      {typeof count === 'number' && <span className={styles.count}>{count}</span>}
    </button>
  );
}
